import React, { useMemo, useState } from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { ControlBarReact } from 'common/widgets/control-bar';
import { BreakdownDropMenu } from 'apps/boards/src/dashboards-app/components/global-filter-bar/breakdown-menu';
import { transformToQuerySegmentEntries } from 'common/query-builder/query-builder/util';
import { getSelectedLabel } from 'common/query-builder/query-block/properties-menu/util';
import { useDataGroups } from 'common/contexts/react/data-group-context';
import { useCohorts } from 'common/contexts/react/cohorts-context';
import { segmentationToPropertySelection } from 'common/query-builder/query-block/segment-menu/util';
import { truncate } from 'common/util/string';
import { BreakdownEvents, track } from 'apps/boards/src/dashboards-app/components/global-filter-bar/tracking';
import { Segmentation } from 'common/types/reports/query';
import { getFirstSegment, getSegmentValueFromSegmentation, Segment } from 'common/query-builder/query-block/segment-menu/types';
import styles from './index.module.styl';
export function BreakdownItem(props: {
  breakdown: Segmentation;
  onChange: (breakdown: Segmentation) => void;
  onClickDelete: () => void;
  projectId: number;
  workspaceId: number;
  userId: number;
  trackName: string;
  onTrack: (ev: CustomEvent) => void;
}) {
  const {
    breakdown
  } = props;
  const [open, setOpen] = useState(false);
  const {
    t,
    print
  } = useTranslation();
  const dataGroups = useDataGroups();
  const cohortsStore = useCohorts();
  const propertyName = useMemo(() => {
    const entry = transformToQuerySegmentEntries([getSegmentValueFromSegmentation(breakdown)])[0];
    const selected = segmentationToPropertySelection(entry.event);
    return getSelectedLabel({
      selected,
      dataGroups: [...Object.values(dataGroups.value)],
      cohortsStore,
      expandListProperties: false
    });
  }, [breakdown, dataGroups.value, cohortsStore]);
  const onClickDelete = () => {
    track(BreakdownEvents.DeleteBreakdown, {
      propertyName: print(propertyName)
    });
    props.onClickDelete();
  };
  const onChange = (newBreakdown: Segment) => {
    track(BreakdownEvents.EditBreakdown, {
      propertyName: print(propertyName)
    });
    props.onChange(getFirstSegment(newBreakdown));
  };
  return <div className={styles.item} data-sentry-component="BreakdownItem" data-sentry-source-file="breakdown-item.tsx">
      <span className={styles.itemLabel}>{t("boards.query-bar.breakdown-by")}</span>
      {" "}
      <span className={styles.itemValue}>{truncate(print(propertyName), 20)}</span>
      <ControlBarReact className={styles.itemActions} theme={ButtonTheme.Tertiary} size={ButtonSize.Small} overflowControls={[{
      items: [{
        label: t("common.edit"),
        icon: "edit",
        onSelect: () => setOpen(true)
      }, {
        label: t("query-builder.actions.remove"),
        icon: "trashcan",
        onSelect: onClickDelete
      }]
    }]} overflowIcon='ellipsis' data-sentry-element="ControlBarReact" data-sentry-source-file="breakdown-item.tsx" />
      {open && <BreakdownDropMenu breakdown={getSegmentValueFromSegmentation(breakdown)} onCommit={onChange} onClose={() => setOpen(false)} projectId={props.projectId} workspaceId={props.workspaceId} userId={props.userId} trackName={props.trackName} onTrack={props.onTrack} />}
    </div>;
}